<!-- Catalogue quality picker: sheet visibility and selector feed only. -->
<script lang="ts">
  import Sheet from './Sheet.svelte';
  import SourcePicker from './SourcePicker.svelte';
  import { count } from './format';
  import { selectorFeed, type SourceSelector } from './picker.svelte';

  interface Props {
    open?: boolean;
    selector: SourceSelector;
    /** What is being watched, for the sheet header. */
    heading: string;
    onclose?: () => void;
  }

  let { open = $bindable(false), selector, heading, onclose }: Props = $props();

  const feed = $derived(selectorFeed(selector));
  const caption = $derived(count(selector.candidates.length, 'copy', 'copies'));

  function shut(): void {
    open = false;
    onclose?.();
  }
</script>

<Sheet bind:open title={heading} caption={caption} {onclose}>
  <!-- Mounted only while the dialog is up: the picker starts its bytes=0-0
       placeholder screen on mount, and a closed sheet must not spend requests. -->
  {#if open}
    <SourcePicker {feed} onchosen={shut} />
  {/if}
</Sheet>
